export const personalDataControllerContacts = [
    {
        icon: '/assets/svg/building-icon.svg',
        title: 'PRIVACY_POLICY_COMPANY',
        value: 'PRIVACY_POLICY_COMPANY_ADDRESS'
    },
    {
        icon: '/assets/svg/building-icon.svg',
        title: 'PRIVACY_POLICY_ORG_NUMBER',
        value: 'PRIVACY_POLICY_ORG_NUMBER_VALUE'
    },
    {
        icon: '/assets/svg/phone-icon.svg',
        title: 'PRIVACY_POLICY_PHONE',
        value: 'PRIVACY_POLICY_PHONE_VALUE'
    },
    {
        icon: '/assets/svg/mail-icon.svg',
        title: 'PRIVACY_POLICY_EMAIL',
        value: 'PRIVACY_POLICY_EMAIL_VALUE'
    }
];

export const dpoContacts = [
    {
        icon: '/assets/svg/mail-icon.svg',
        title: 'PRIVACY_POLICY_DPO_EMAIL',
        value: 'PRIVACY_POLICY_DPO_EMAIL_VALUE'
    }
];

export const privacyPolicySections = [
    {
        title: 'PRIVACY_POLICY_AT_INVOZIO',
        content: 'PRIVACY_POLICY_AT_INVOZIO_DESCRIPTION'
    },
    {
        title: 'PRIVACY_POLICY_AT_CONTROLLER',
        content: 'PRIVACY_POLICY_AT_CONTROLLER_DESCRIPTION'
    },
    {
        title: 'PRIVACY_POLICY_PERSONAL_DATA',
        content: 'PRIVACY_POLICY_PERSONAL_DATA_DESCRIPTION'
    },
    {
        title: 'PRIVACY_POLICY_WHAT_PERSONAL_DATA',
        content: 'PRIVACY_POLICY_WHAT_PERSONAL_DATA_DESCRIPTION'
    },
    {
        title: 'PRIVACY_POLICY_SELF_EMPLOYED',
        content: 'PRIVACY_POLICY_SELF_EMPLOYED_DESCRIPTION'
    },
    {
        title: 'PRIVACY_POLICY_CUSTOMERS_SUPPLIERS',
        content: 'PRIVACY_POLICY_CUSTOMERS_SUPPLIERS_DESCRIPTION'
    },
    {
        title: 'PRIVACY_POLICY_DATA_COLLECTION',
        content: 'PRIVACY_POLICY_DATA_COLLECTION_DESCRIPTION'
    }
];